import styled from 'styled-components'

export const ContentContainer = styled.div`
    margin-top: 4rem;
    position: relative;
    padding-bottom: 5rem;

    h3 {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        color: #333;
    }
`

export const BoxContainer = styled.div`
    width: 90%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 5rem;
    text-align: center;

    background: #eee;
    padding: 1rem 2rem;
    border-radius: 3px;
    box-sizing: border-box; 

    h3 {
        margin: 0;
    }

    hr {
        margin: .5rem auto;
    }

    @media (max-width: 500px) {
        font-size: .8rem;
    }
`
